export const IsWorker = (): boolean =>
  typeof self === "object" &&
  typeof (self as any).importScripts === "function" &&
  typeof window === "undefined"
